import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import dynamic from 'next/dynamic'
import Image from "next/image";
import { urlForImage } from '~/lib/sanity.image';
import { Typography } from '../../lib/mt-native'

import "react-multi-carousel/lib/styles.css";

const Carousel = dynamic(() => import('react-multi-carousel'), {
  ssr: false,
});

export default function CarouselTitle({ slides }) {
  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 768 }, items: 1 },
    mobile: { breakpoint: { max: 767, min: 375 }, items: 1 },
  }

  const PrevArrow = ({ onClick, disabled }) => (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="!absolute top-2/4 left-0 -translate-y-2/4 rounded-full select-none transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none w-12 max-w-[48px] h-12 max-h-[48px] text-white hover:bg-white/10 active:bg-white/30 grid place-items-center"
    >
      <ArrowLeftIcon strokeWidth={2} color="black" className="-ml-5 h-7 w-7" />
    </button>
  )

  const NextArrow = ({ onClick, disabled }) => (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="!absolute top-2/4 right-0 -translate-y-2/4 rounded-full select-none transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none w-12 max-w-[48px] h-12 max-h-[48px] text-white hover:bg-white/10 active:bg-white/30 grid place-items-center"
    >
      <ArrowRightIcon strokeWidth={2} color="black" className="ml-5 h-7 w-7" />
    </button>
  )

  return (
    <div className="overflow-hidden">
      <Carousel
        responsive={responsive}
        infinite={false}
        autoPlay={false}
        swipeable={true}
        draggable={true}
        showDots={false}
        partialVisible={false}
        customLeftArrow={<PrevArrow />}
        customRightArrow={<NextArrow />}
      >
        {slides?.length
          ? slides.map((slide) => (
              <div
                key={String(slide._id ?? slide._key)}
                className="relative h-full w-full"
              >
                {slide.image && urlForImage(slide.image) && (
                  <Image
                    src={urlForImage(slide.image).url()}
                    alt={slide.title ? slide.title : 'slide'}
                    width={0}
                    height={0}
                    sizes="100vw"
                    style={{ width: '100%', height: 'auto' }}
                    className="h-full w-full object-cover"
                  />
                )}
                {slide.title && (
                  <div className="absolute inset-0 grid h-full w-full place-items-end">
                    <div className="w-full text-left pl-10">
                      <Typography
                        variant="h1"
                        color="white"
                        className="mb-10 text-3xl md:text-3xl lg:text-6xl"
                      >
                        {slide.title}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            ))
          : null}
      </Carousel>
    </div>
  );
}
